import { render, staticRenderFns } from "./footer_dynamic.vue?vue&type=template&id=5a88d2fd"
import script from "./footer_dynamic.vue?vue&type=script&lang=js"
export * from "./footer_dynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementBuilder: require('/root/containers/hermes_eshop/components/core/elementBuilder.vue').default})
